import Flickity from 'flickity';
import 'flickity-imagesloaded';
import 'flickity-as-nav-for';
import throttle from 'lodash/throttle';

export default {

  defaults: {
    cellSelector: '.slider__slide',
    contain: true,
    adaptiveHeight: false,
    imagesLoaded: true,
    pageDots: true,
    prevNextButtons: true,
    groupCells: false,
    cellAlign: 'left',
    wrapAround: false
  },

  init(options) {
    this.options = { ...this.defaults, ...options };
    this.carouselHeight();
    this.customizeControls();
    this.eventListeners();
  },

  create(el, options) {
    this.el = el;
    this.options = { ...this.options, ...options };

    if(Flickity.data(this.el) && this.el.classList.contains('flickity-enabled')) {
      this.carousel.resize();
    } else {
      this.carousel = new Flickity(this.el, this.options);
    }

    this.carousel.on('dragStart', () => {
      el.classList.add('is-slider-dragging');
    });

    this.carousel.on('dragEnd', () => {
      el.classList.remove('is-slider-dragging');
    });

    return this.carousel;
  },

  carouselHeight() {
    let elem = document.querySelector('.product-carousel');

    if(elem) {
      let width = elem.offsetWidth;
      let height = width + (width * 0.1744) + 16;

      elem.style.setProperty('--gallery-height', `${height}px`);
    }
  },

  customizeControls() {
    var elems = document.querySelectorAll('.slider--controls');

    elems.forEach(function(elem) {
      var sizer = elem.querySelector('.slider--controls__sizer');

      if(sizer) {
        elem.style.setProperty('--controls-height', `${sizer.offsetHeight}px`);
      }
    });
  },

  eventListeners() {
    window.addEventListener('resize', throttle(function() {
      Sliders.customizeControls();
      Sliders.carouselHeight();
    }), 200);
  }
}
